import "./polyfills/symbolObservable";
import { setLoggingConfig } from "./utils/logger";
import { runtimeConfig } from "./config/runtimeConfig";

// Configure logging once at the application entry point before any components mount.
const hostname = window.location.hostname.toLowerCase();
const isLocalOrDev = hostname === "localhost" || hostname.startsWith("dev");
setLoggingConfig({
  enabled: true,
  level: isLocalOrDev ? "debug" : runtimeConfig.logLevel || "info",
});

import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { sentinelConfig } from "./config/sentinelConfig";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { Harmony } from "@uhg-harmony/react";
import ErrorBoundary from "./components/ErrorBoundary";

const POST_SIGNIN_PATH = "/";

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <AuthProvider
          {...sentinelConfig}
          onSigninCallback={() => {
            window.history.replaceState({}, document.title, POST_SIGNIN_PATH);
          }}
        >
          <Harmony
            appId={runtimeConfig.harmonyAppId}
            licenseKey={runtimeConfig.harmonyLicenseKey}
            spacing
            grid
          >
            <App />
          </Harmony>
        </AuthProvider>
      </Provider>
    </ErrorBoundary>,
  );
}
